// Not generated from samples: written from Appboy::Communication::Segment::B2bFilter.

import { z } from "zod";
import { b2bFilterConditionSchema } from "./b2bFilterConditionSchema";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const b2bFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("b2b_filter"),
  // The real comparisons live on each condition; this one is the filter's own comparison field.
  comparison_key: z.string(),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on (B2bFilter#get_raw_value).
  raw_value: z.object({ conditions: z.array(b2bFilterConditionSchema) }).optional(),
  value: z.object({ conditions: z.array(b2bFilterConditionSchema) }),
  varies_by_app_group: z.literal(false),
});
